import axios from 'axios';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as types from '../constants/actionTypes';
import * as api from '../tools/apiConfig';
const PRODUCTION_IMAGE_URL = require('../constants/constant').PRODUCTION_IMAGE_URL
export function getDisputeSubDisputeList() {

    return function (dispatch, getState) {
        axios.get(api.GET_DISP_SUB_LIST, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GET_DISP_SUB_LIST, listing: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}

export function getDisputeSubDisputeListAdmin(data) {
    console.log("ddddddd", data)
    return function (dispatch, getState) {
        axios.post(api.GET_DISP_SUB_LIST_ADMIN, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    if (response.data.code == 200) {
                        // toast.info("Calendar Access Is Generated")
                        return dispatch({ type: types.GET_DISP_SUB_LIST_ADMIN, listing: response.data.data });
                    }
                }
            })
            .catch(function (error) {
                console.log("errrrrr", error)
            });
    }
}
export function getSubdisputeDetail(data) {

    return function (dispatch, getState) {
        axios.post(api.GET_SUBDISPUTE_DETAIL, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GET_SUBDISPUTE_DETAIL, subDisputeDetail: response.data.data });
                }
            })
            .catch(function (error) {
            });
    }
}
export function getSubdisputeList(data) {
    console.log("999999", data)
    return function (dispatch, getState) {
        axios.post(api.GET_SUBDISPUTE_LIST, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GET_SUBDISPUTE_LIST, subDisputeList: response.data.data });
                }
            })
            .catch(function (error) {
            });
    }
}
export function submitDisputeToZendesk(data, props) {
    console.log("submitDisputeToZendesk", data)
    return function (dispatch, getState) {
        axios.post(api.SUBMIT_DISPUTE_TO_ZENDESK, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    props.history.push('/disputes/disputeSubmitted')
                    toast.info("Your Ticket has been Created")
                    // return dispatch({ type: types.GET_SUBDISPUTE_LIST, subDisputeList: response.data.data });
                }
            })
            .catch(function (error) {
            });
    }
}
export function viewReceipt(data) {
    console.log("ViewRecipt", data)
    return function (dispatch, getState) {
        axios.post(api.VIEW_RECIPT, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    console.log("dddddddd", response.data)
                    window.open(PRODUCTION_IMAGE_URL+"uploads/"+localStorage.getItem('userId')+response.data.data)
                    // toast.info("Calendar Access Is Generated")
                    // return dispatch({ type: types.GET_SUBDISPUTE_LIST, subDisputeList: response.data.data });
                }
            })
            .catch(function (error) {
            });
    }
}
export function searchDispute(data) {
    console.log("ViewRecipt", data)
    return function (dispatch, getState) {
        axios.post(api.SEARCH_DISPUTE, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GET_SEARCHED_DISPUTE_LIST, searchedDisputedList: response.data.data });
                }
            })
            .catch(function (error) {
            });
    }
}





export function putGapiToken(data, props) {
    console.log("ddddd", data)
    return function (dispatch, getState) {

        axios.post(api.PUT_GAPI_TOKEN, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE AFTER CODE", response)
                if (response.data.code == 200) {

                    if (response.data.data == null) {
                        toast.info("Calendar Access Is Revoked")
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: false });
                    }
                    else {
                        props.history.push('/specialist/my-settings');
                        toast.info("Calendar Access Verified")
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: true });
                    }
                }
            })
            .catch(function (error) {
                console.log("RESPONSE AFTER CODE", error)

            });
    }
}

export function getUsersGoogleSyncStatus(data) {
    console.log("GETUSERSSYNCSTATUS", data)
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE))))))))--->>", response)
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function getOutlookAuth() {

    return function (dispatch, getState) {
        axios.get(api.OUTLOOK_AUTH, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("response", response)
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GAPI_AUTH, urlToRedirect: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}

export function putOutlookToken(data, props) {
    console.log("ddddd", data)
    return function (dispatch, getState) {
        axios.post(api.PUT_OUTLOOK_TOKEN, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE AFTER CODE", response)
                if (response.data.code == 200) {

                    if (response.data.data == null) {
                        toast.info("Outlook Calendar Access Is Revoked")
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: false });
                    }
                    else {
                        props.history.push('/specialist/my-settings');
                        toast.info("Sync to Outlook Calendar Successful")
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: true });
                    }
                }
            })
            .catch(function (error) {
                console.log("RESPONSE AFTER CODE", error)

            });
    }
}


export function getUsersOutlookSyncStatus(data) {
    console.log("GETUSERSSYNCSTATUS", data)
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_OUTLOOK_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE))))))))--->>", response)
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function getUsersiCloudSyncStatus(data) {
    console.log("GETUSERSSYNCSTATUS", data)
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_ICLOUD_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE))))))))--->>", response)
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}


export function getiCalFile() {
    return function (dispatch) {
        axios.get(api.GET_iCAL_FILE, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GAPI_AUTH, urlToRedirect: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}

export function storeUseriCloudEmail(data, props) {
    return function (dispatch, getState) {
        axios.post(api.STORE_USER_ICLOUD_EMAIL, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE))))))))--->>", response)
                if (response.data.code == 200) {

                    if (response.data.data) {
                        toast.info(response.data.message);
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        toast.info(response.data.message);
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function removeiCalFromUser(data, props) {
    return function (dispatch, getState) {
        axios.post(api.REMOVE_USER_ICLOUD_EMAIL, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                console.log("RESPONSE))))))))--->>", response)
                if (response.data.code == 200) {

                    if (response.data.data) {

                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}
export function addDisputeCategory(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.ADD_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
					toast.info('Dispute added successfully')
                    return dispatch({ type: types.ADD_DISPUTE_CONTENT, data: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function addSubDisputeCategory(data,props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.ADD_SUB_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
                    toast.info('Sub Dispute added successfully');
                    return dispatch({ type: types.ADD_SUB_DISPUTE_CONTENT, data: response.data.data });
                } else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function editSubDisputeCategory(data,props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.EDIT_SUB_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
                    toast.info('Sub Dispute added successfully');
                    // return dispatch({ type: types.ADD_SUB_DISPUTE_CONTENT, data: response.data.data });
                } else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function deleteSubDispute(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.DELETE_SUB_DISPUTE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
                    toast.info('Sub Dispute added successfully');
                    // return dispatch({ type: types.ADD_SUB_DISPUTE_CONTENT, data: response.data.data });
                } else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function getDisputedAppointmentDetails(data) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.GET_DISPUTED_APPOINTMENT_DETAILS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    // props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
                    // toast.info('Sub Dispute added successfully');
                    return dispatch({ type: types.GET_DISPUTED_APPOINTMENT_DETAILS, disputedAppointmentDetails: response.data.data });
                } else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
export function markUserDisputeAsResolved(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.MARK_USER_DISPUTE_AS_RESOLVED, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
                console.log("==>", response)
				if (response.data.code == 200) {
                    let appointmentObj = {
                        count: 10,
                        status: true,
                        page: 1,
                    };
                    props.appointmentactions.getAllDisputedAppointments(appointmentObj, props);
                    toast.info(response.data.message);
                    props.history.push('/user/disputes');
                    return dispatch({ type: types.MARK_USER_DISPUTE_AS_RESOLVED, data: response.data.data });
                } else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}else if(response.data.description.code == "charge_already_captured" ) {
                    props.history.push('/user/disputes');
					toast.info("This Appointment has already been refunded");
                }
			})
			.catch(function (error) { });

	}
}

export function addLanguageCategory(data, props) {
	// debugger;
	return function (dispatch, getState) {
		axios.post(api.ADD_LANGUAGE_CATEGORY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    let appDetail = {
                        // patientId: this.props.match.params.patientId,
                        count: 10,
                        page: 1
                    }
                    props.disputeActions.getDisputeSubDisputeListAdmin(appDetail);
					toast.info('Dispute added successfully')
                    return dispatch({ type: types.ADD_DISPUTE_CONTENT, data: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					history.push('/user');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}
